/* PRODUCTS */
export const SET_DRAFT = "SET_DRAFT"
export const SET_DRAFT_SUCCESS = "SET_DRAFT_SUCCESS"
export const SET_DRAFT_FAIL = "SET_DRAFT_FAIL"